import { LevelOfEducationResponse, LevelOfEducationResponseItem } from '@/types/service-response'
import store from '@/store'
import { QcqCommonGridItem, UiLanguageItem, UiLanguageList } from '@/types'

export interface LevelOfEducationItem {
  id: number
  code: string
  description: string
}

export class LevelOfEducation {
  private constructor (
    readonly dataMap: Map<string, LevelOfEducationItem>
  ) {}

  get commonGridData (): QcqCommonGridItem {
    const selectedUiLanguage: UiLanguageItem | undefined = store.state.selectedUiLanguage
    const value = this.dataMap.get(selectedUiLanguage!.code)
    const newItem: QcqCommonGridItem = {
      id: value!.id,
      code: value!.code,
      description: value!.description
    }
    return newItem! // TODO CAN BE UNDEFINED
  }

  static createListFromResponse (responseData: LevelOfEducationResponse): Array<LevelOfEducation> {
    const levelOfEducationList: Array<LevelOfEducation> = []
    let result: Map<number, Array<LevelOfEducationResponseItem>> = new Map()
    const languageList: UiLanguageList = store.state.uiLanguageList

    responseData.forEach((responseItem: LevelOfEducationResponseItem) => {
      if (responseItem.SpracheID !== null) {
        if (!result.has(responseItem.BildungsgradeID)) {
          result.set(responseItem.BildungsgradeID, [responseItem])
        } else {
          result.get(responseItem.BildungsgradeID)!.push(responseItem)
        }
      }
    })

    result.forEach((responseItemArray: Array<LevelOfEducationResponseItem>) => {
      let dataMap: Map<string, LevelOfEducationItem> = new Map()
      responseItemArray.forEach((responseItem: LevelOfEducationResponseItem) => {
        const languageItem = languageList.find((languageItem: UiLanguageItem) => languageItem.syzId === responseItem.SpracheID)
        if (languageItem) {
          let row: LevelOfEducationItem = {
            id: responseItem.BildungsgradeID,
            code: responseItem.BildungsgradeCode,
            description: responseItem.BildungsgradeBezeichnung
          }
          dataMap.set(languageItem.code, row)
        }
      })
      levelOfEducationList.push(new LevelOfEducation(dataMap))
    })
    return levelOfEducationList
  }
}